<template>
  <div class="context-menu" @mouseleave="handleMouseLeave" @mouseenter="handleMouseEnter">
    <ContextMenu
      v-if="isOpen"
      :x="contextMenuPosition.x"
      :y="contextMenuPosition.y"
      @close="handleClose"
    >
      <div
        class="menu-container"
        :style="{ 'max-width': contextMenuPosition.maxWidth + 'px', 'max-height': 175 + 'px'}"
      >
        <h3 class="document-title" v-if="isPresent(payload.data.document_display_name)" @click="onClick(payload.buttons[0])">{{ payload.data.document_display_name }}</h3>
        <h3 class="document-title" v-else>{{ payload.data.document_title }}</h3>
        <h5 class="document-summary" v-if="isPresent(payload.data.document_summary)">{{ payload.data.document_summary }}</h5>
        <h5 class="document-section-title" v-if="isPresent(payload.data.document_section_title)">{{ payload.data.document_section_title }}<span v-if="isPresent(payload.data.document_section_id)"> - ({{ payload.data.document_section_id }})</span></h5>
        <h5 class="document-section-title" v-else>{{ payload.data.document_name }} ({{ payload.data.document_section_id }})</h5>
      </div>
    </ContextMenu>
  </div>
</template>
<script>
import ContextMenu from './ContextMenu'
import MenuItem from './MenuItem'
import DOMPurify from 'dompurify'
export default {
  name: 'TopKOverlay',
  components: {
    ContextMenu,
    MenuItem
  },
  props: {
    payload: {
      type: Object,
      required: true
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    enabledOptions: {
      type: Object,
      default: () => ({})
    },
    contextMenuPosition: {
      type: Object,
      default: () => ({})
    },
    handleMouseEvent: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isCannedResponseModalOpen: false,
      showTranslateModal: false,
      showDiscardModal: false
    }
  },
  computed: {
    answerPrefix () {
      return $store.getters.getBotLanguages.translations.relatedQuestions.answerPrefix
    },
    containsButtons () {
      return this.payload && this.payload.buttons && this.payload.buttons.length > 0
    }
  },
  methods: {
    onClick (button) {
      if (this.containsButtons) {
        kserver.CoreAPI.sendMessage(button.payload, 'POSTBACK')
      }
    },
    handleOpen (e) {
      this.$emit('open', e)
    },
    handleClose (e) {
      this.$emit('close', e)
    },
    handleMouseEnter() {
      if (this.handleMouseEvent) {
        this.$emit('open')
      }
    },
    handleMouseLeave(e) {
      if (this.handleMouseEvent) {
        this.$emit('close', e)
      }
    },
    isPresent(val) {
      return !!val && !(val.startsWith('${') && val.endsWith('}'))
    }
  }
}
</script>
<style scoped>
.menu-container {
  max-width: 300px;
  border: 1px solid var(--playground-1-color);
  background-color: var(--component-background-color);
  box-shadow: var(--shadow);
  background-color: rgb(255 255 255 / 1);
  position: relative;
  overflow: hidden;
  padding: 15px 20px 10px 20px;
  text-overflow: ellipsis;
}
.menu-container .document-title {
  color: var(--primary-action-color);
  font-size: 14px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
.menu-container .document-summary {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  line-clamp: 5;
  -webkit-box-orient: vertical;
}
.button {
    margin-bottom: 0px;
    display: inline-flex;
    height: 2.5rem;
    align-items: center;
}
.button.small {
    font-size: 0.75rem;
    font-size: var(--font-size-mini);
}
.button.clear {
    border: 1px solid #1f93ff;
    color: #1f93ff;
}
.button.clear, .button.clear:hover, .button.clear:focus {
    background-color: transparent;
}
.button.small {
    height: 2rem;
    padding-bottom: 0.25rem;
    padding-top: 0.25rem;
}
.button.button--only-icon {
    width: 2.5rem;
    justify-content: center;
    padding-left: 0px;
    padding-right: 0px;
}
.button.clear.secondary {
    border: 1px solid #5d7592;
    color: #5d7592;
}
.button.clear.secondary, .button.clear.secondary.disabled, .button.clear.secondary[disabled], .button.clear.secondary:hover, .button.clear.secondary:hover.disabled, .button.clear.secondary:hover[disabled], .button.clear.secondary:focus, .button.clear.secondary:focus.disabled, .button.clear.secondary:focus[disabled] {
    border-color: transparent;
}
.button.clear.secondary {
    color: hsl(207 5.6% 31.6% / 1);
}
.button.button--only-icon.small {
    width: 2rem;
}
.outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
}
.z-\[9999\] {
    z-index: 9999;
}
.fixed {
    position: fixed;
}
.document-title {
  cursor: pointer;
}

.document-section-title {
  position: relative;
  font-weight: bold;
}
</style>